module.exports = __webpack_public_path__ + "img/graph_3.daeb9b7c.svg";